const key = 'fv_pending_discount_code';
let pending = '';
let hideTimer;
const storage = (fn) => { try { return fn(); } catch { return null; } };
function remember(code) { pending = code.toUpperCase(); storage(() => sessionStorage.setItem(key, pending)); }
function check() {
  const code = pending || storage(() => sessionStorage.getItem(key));
  if (!code) return;
  const applied = [...document.querySelectorAll('.cart-discount__pill[data-discount-code]')].some(pill => pill.dataset.discountCode.toUpperCase() === code);
  if (!applied) return;
  pending = '';
  storage(() => sessionStorage.removeItem(key));
  let toast = document.getElementById('fv-discount-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'fv-discount-toast';
    toast.className = 'fv-discount-toast';
    toast.setAttribute('role', 'status');
  }
  const surface = document.querySelector('#cart-drawer dialog[open]') || document.body;
  surface.append(toast);
  const messages = document.querySelector('[data-fv-discount-success]');
  toast.textContent = messages?.dataset.fvDiscountSuccess || 'Discount applied';
  toast.classList.add('is-visible');
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 4000);
}
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-fv-discount-link]');
  if (link) {
    remember(link.dataset.fvDiscountLink);
    const scope = link.closest('.cart-drawer__summary, .cart-page__summary') || document;
    const form = scope.querySelector('.cart-discount__form');
    const component = form?.closest('cart-discount-component');
    if (form && typeof component?.applyDiscount === 'function') {
      event.preventDefault();
      form.closest('details').open = true;
      form.querySelector('[name="discount"]').value = link.dataset.fvDiscountLink;
      form.requestSubmit();
    }
  }
  const button = event.target.closest('.cart-discount__form button[type="submit"]');
  const code = button?.form?.querySelector('[name="discount"]')?.value.trim();
  if (code) remember(code);
}, true);
document.addEventListener('submit', event => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.matches('.cart-discount__form')) return;
  const code = event.target.querySelector('[name="discount"]')?.value.trim();
  if (code) remember(code);
}, true);
new MutationObserver(check).observe(document.documentElement, { childList:true, subtree:true });
check();
